import React from "react";
import { AnimationControls, motion } from "framer-motion";
import { Title, Subtitle } from "../../styles";
import { EntryAnimationWrapper } from "../EntryAnimationWrapper";

interface Props {
  animationControls: AnimationControls;
  children: React.ReactNode;
}

export function FamilyGoalsWrapper({ animationControls, children }: Props) {
  return (
    <motion.div animate={animationControls}>
      <EntryAnimationWrapper>
        <Title>Family Dance Goal</Title>
        <Subtitle>
          What&apos;s your main goal for your family using STEEZY?
        </Subtitle>
        {children}
      </EntryAnimationWrapper>
    </motion.div>
  );
}
